/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useState } from 'react';

import {
  BodyMenuItem,
  BodyMenuItemAction,
  BodyMenuIconContent,
  BodyMenuIcon,
  BodyMenuText,
  BodyMenuImageContent,
} from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function ButtonMenu({
  item,
  active,
  onPress,
  focused,
}: {
  item: {
    icon?: { icon: string; width: number; height: number; fill: string };
    image?: string;
    title?: string;
    id?: number;
  };
  active?: boolean;
  onPress?: () => void;
  focused?: boolean;
}) {
  return (
    <>
      <BodyMenuItemAction onPress={onPress}>
        <BodyMenuItem active={focused || active}>
          {item.image ? (
            <BodyMenuImageContent source={item.image} active={focused || active} />
          ) : (
            <BodyMenuIconContent active={focused || active}>
              <BodyMenuIcon {...item.icon} active={focused || active} />
            </BodyMenuIconContent>
          )}
          <BodyMenuText>{item.title}</BodyMenuText>
        </BodyMenuItem>
      </BodyMenuItemAction>
    </>
  );
});
